import { Component, HostBinding, Inject, Input } from '@angular/core';
import { APP_ASSETS_PATH } from '@sg/shell-app/src/app/app.module';
import { counterPartiesMapper } from '../../counterPartiesMapper';
import { MULTI_COLOR_LOGO_LEGAL_ENTITIES } from './multi-color-legal-entities-logo';

const DEFAULT_CP_ICON = 'sg-cp-default';

export interface SgCounterPartyLogoFallback {
  src: string;
  size?: 'small' | 'large' | 'xlarge';
  background?: string;
}

@Component({
  selector: 'sg-counter-party-logo',
  templateUrl: './counter-party-logo.component.html',
  styleUrls: ['./counter-party-logo.component.scss'],
  standalone: false,
})
export class SgCounterPartyLogoComponent {
  private multiColorLogoLegalEntities = MULTI_COLOR_LOGO_LEGAL_ENTITIES;
  private counterPartiesColorMapper = {
    'sg-cp-moraBanc-color': '#004581',
    'sg-cp-santander-color': '#EC0000',
    'sg-cp-ubs-color': '#010101',
    'sg-cp-swissquote-color': '#FA5B35',
    'sg-cp-barclays-color': '#009DDF',
    'sg-cp-bank-of-nova-scotia-color': '#EE3224',
    'sg-cp-morgan-stanley-color': '#002C51',
    'sg-cp-leumi-color': '#175AB1',
    'sg-cp-bux-color': '#FF3D67',
    'sg-cp-freetrade-color': '#F7618B',
    'sg-cp-zkb-color': '#074598',
    'sg-cp-jpm-color': '#3A2206',
  };

  @Input() legalEntityCode: string;
  @Input() size: 'small' | 'large' | 'xlarge' = 'large';
  @Input() svgFallback?: SgCounterPartyLogoFallback;

  @HostBinding('style.background-color')
  get hostBackgroundColor() {
    return this.hasFallbackSvg() ? (this.svgFallback?.background ?? null) : null;
  }

  constructor(@Inject(APP_ASSETS_PATH) public assetsPath: string) {}

  isMultiColorLogo() {
    return this.multiColorLogoLegalEntities.indexOf(this.legalEntityCode) > -1;
  }

  getMultiColorLogo() {
    return `${this.assetsPath}images/logos/${this.legalEntityCode.toUpperCase()}.svg`;
  }

  hasFallbackSvg() {
    return !!this.svgFallback?.src && !counterPartiesMapper[this.legalEntityCode];
  }

  getFallbackSvgSrc() {
    return `${this.assetsPath}${this.svgFallback.src}`;
  }

  getFallbackSvgClass() {
    return `${this.svgFallback?.size ?? 'large'}-logo`;
  }

  getSingleColorLogo() {
    return counterPartiesMapper[this.legalEntityCode] ?? DEFAULT_CP_ICON;
  }

  getSingleColorClass() {
    return !counterPartiesMapper[this.legalEntityCode]
      ? 'small-logo'
      : this.size === 'xlarge'
        ? 'xlarge-logo'
        : 'large-logo';
  }

  getMultiColorClass() {
    return `${this.size}-logo`;
  }

  getMatIconColor() {
    return this.counterPartiesColorMapper[counterPartiesMapper[this.legalEntityCode]];
  }
}
